import moment from 'moment';

/* If there is not any slide to the hero - remove it from DOM */
$('.hero').each(function(){
    if ($('.hero__slide',this).length === 0) {
        $(this).remove();
        console.log("[hero] no slide -> remove from DOM")
    }
});

export const $win = $(window);
export const $doc = $(document);
export const $header = $('.header');
export const $wrapper = $('.wrapper');
export const $main = $('.main');
export const $hero = $('.hero');
export let manualUpdate = false;

export const toggleManualUpdate = () => {
	manualUpdate = !manualUpdate;
}

export const isValidDate = (date) => {
  return date instanceof Date && !isNaN(date);
}

export function getCurrentDevice(){
	let currentDevice = 'desktop';
	if ($win.width() <= 767) {
		currentDevice = 'mobile'
	} else if ($win.width() < 1200) {
		currentDevice = 'tablet'
	} else {
		currentDevice = 'desktop'
	}
	return currentDevice;
}

export const keys = {
	end: 35,
	home: 36,
	left: 37,
	up: 38,
	right: 39,
	down: 40,
	delete: 46,
	enter: 13,
	space: 32,
	tab: 9,
	escape: 27
};

export function videoControlPlayer($iframe, state) {
	let iframeSrc = $iframe.attr('src');
	if (!iframeSrc) return
	iframeSrc = iframeSrc.replace('#play', '')
						 .replace('#pause', '');
	$iframe.attr('src', `${iframeSrc}#reset`);
	setTimeout(function(){
		$iframe.attr('src', `${iframeSrc}#${state}`)
	}, 100);
	$iframe.attr('src', `${iframeSrc}#${state}`)
}

export function mapOffsetCenter(map, latlng, offsetx, offsety) {
	const scale = Math.pow(2, map.getZoom());
	const nw = new google.maps.LatLng(
	map.getBounds().getNorthEast().lat(), map.getBounds().getSouthWest().lng());

	const worldCoordinateCenter = map.getProjection().fromLatLngToPoint(latlng);
	const pixelOffset = new google.maps.Point((offsetx / scale) || 0, (offsety / scale) || 0)

	const worldCoordinateNewCenter = new google.maps.Point(
	worldCoordinateCenter.x - pixelOffset.x, worldCoordinateCenter.y + pixelOffset.y);

	const newCenter = map.getProjection().fromPointToLatLng(worldCoordinateNewCenter);

	map.setCenter(newCenter);
}

export function getDuplicateIds(container) {
	const elements = [...container.querySelectorAll('[id]')];
	const ids = [];
	const dups = [];

	elements.map(el => ids.includes(el.id) ? dups.push(el) : ids.push(el.id));
	
	return dups;
}

export function updateIds(el) {
	const $el = $(el);
	const id = $el.attr('id');
	const newId = id + '-' + new Date().getTime();

	$el.attr('id', newId)

	$(`[aria-labelledby="${id}"]`).last().attr('aria-labelledby', newId);
}

export const dynamizeLocales = container => {
	$('.js-dynamic-locale', container).each((index, element) => {
		let str = element.innerText;

		const variables = str.match(/{([^}]+)}/g) || [];

		variables.forEach(variable => {
			const key = variable.replace('{', '').replace('}', '');

			let param = element.getAttribute(`data-${key}`);

			if (element.hasAttribute(`data-${key}-format`)) {
				param = moment(param).isValid() ? moment(param).format(element.getAttribute(`data-${key}-format`)) : param;
			}

			str = str.replace(variable, param);
		});

		element.innerText = str.trim();
		element.classList.remove('hidden');
	});
}

export const dynamizeWeekdays = container => {
	$('[data-moment-weekdays]', container).each((index, element) => {
		const values = [];

		element.getAttribute('data-moment-weekdays').split(',').forEach((weekday, idx) => {
			if (weekday == 1) values.push(moment.weekdays(idx + 1));
		});

		element.innerText = values.join(', ');
	});
}

$.cachedScript = (url, options) => {
	// Allow user to set any option except for dataType, cache, and url
	options = $.extend( options || {}, {
		dataType: "script",
		cache: true,
		url: url
	});
   
	// Use $.ajax() since it is more flexible than $.getScript
	// Return the jqXHR object so we can chain callbacks
	return $.ajax(options);
};

const isScriptLoaded = {};

export function loadScript(shortName, scriptPath, callback) {
	if (!shortName in isScriptLoaded) isScriptLoaded[shortName] = new Promise(resolve => {
		$.cachedScript(scriptPath).done(() => {
			isScriptLoaded[shortName] = true;

			callback().then(() => {
				resolve();
			})
		});
	});

	return isScriptLoaded[shortName]
}
